// export const BASE_URL = 'http://localhost:8080'
export const BASE_URL = 'https://apix-backend.cfapps.io'
export const BASE_PROJECT_URL = BASE_URL + '/projects'
